const FooterDivider = () => {
    return <div style={{ background: 'linear-gradient(90deg, #D6D6D6 25.31%, #A1A1A1 71.15%)', height: '7vh' }}></div>
}

export default FooterDivider;